export default function BoundaryConfigurator({ fixedRegions, loadRegions, onFixedChange, onLoadChange }) {
  const fixedRegion = fixedRegions[0] || { type: 'extremes', axis: 'y', end: 'min', percent: 5 }
  const loadRegion = loadRegions[0] || { type: 'extremes', axis: 'y', end: 'max', percent: 5 }

  const updateFixed = (field, value) => {
    onFixedChange([{ ...fixedRegion, [field]: value }])
  }

  const updateLoad = (field, value) => {
    onLoadChange([{ ...loadRegion, [field]: value }])
  }

  return (
    <div className="bg-gray-900 rounded-lg p-4">
      <h3 className="text-sm font-semibold text-gray-300 mb-1">Boundary Conditions</h3>
      <p className="text-[11px] text-gray-500 mb-3">Where is the part held, and where is force applied?</p>

      {/* Fixed (constrained) region */}
      <div className="mb-4">
        <p className="text-xs text-blue-400 font-medium mb-2">Fixed (Constrained) Region</p>
        <div className="bg-gray-800 rounded p-2 space-y-2">
          <div className="flex gap-2">
            <label className="flex-1">
              <span className="text-xs text-gray-400">Axis</span>
              <select
                value={fixedRegion.axis}
                onChange={e => updateFixed('axis', e.target.value)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              >
                <option value="x">X</option>
                <option value="y">Y</option>
                <option value="z">Z</option>
              </select>
            </label>
            <label className="flex-1">
              <span className="text-xs text-gray-400">End</span>
              <select
                value={fixedRegion.end}
                onChange={e => updateFixed('end', e.target.value)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              >
                <option value="min">Min (Bottom)</option>
                <option value="max">Max (Top)</option>
              </select>
            </label>
            <label className="w-20">
              <span className="text-xs text-gray-400">%</span>
              <input
                type="number"
                min="1"
                max="50"
                value={fixedRegion.percent}
                onChange={e => updateFixed('percent', parseInt(e.target.value) || 5)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              />
            </label>
          </div>
          <p className="text-[10px] text-gray-500">
            Fix {fixedRegion.end === 'min' ? 'bottom' : 'top'} {fixedRegion.percent}% of nodes along {fixedRegion.axis.toUpperCase()}-axis
          </p>
        </div>
      </div>

      {/* Load application region */}
      <div>
        <p className="text-xs text-orange-400 font-medium mb-2">Load Application Region</p>
        <div className="bg-gray-800 rounded p-2 space-y-2">
          <div className="flex gap-2">
            <label className="flex-1">
              <span className="text-xs text-gray-400">Axis</span>
              <select
                value={loadRegion.axis}
                onChange={e => updateLoad('axis', e.target.value)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              >
                <option value="x">X</option>
                <option value="y">Y</option>
                <option value="z">Z</option>
              </select>
            </label>
            <label className="flex-1">
              <span className="text-xs text-gray-400">End</span>
              <select
                value={loadRegion.end}
                onChange={e => updateLoad('end', e.target.value)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              >
                <option value="min">Min (Bottom)</option>
                <option value="max">Max (Top)</option>
              </select>
            </label>
            <label className="w-20">
              <span className="text-xs text-gray-400">%</span>
              <input
                type="number"
                min="1"
                max="50"
                value={loadRegion.percent}
                onChange={e => updateLoad('percent', parseInt(e.target.value) || 5)}
                className="w-full mt-1 bg-gray-700 border border-gray-600 rounded px-2 py-1 text-xs text-white"
              />
            </label>
          </div>
          <p className="text-[10px] text-gray-500">
            Apply load to {loadRegion.end === 'min' ? 'bottom' : 'top'} {loadRegion.percent}% of nodes along {loadRegion.axis.toUpperCase()}-axis
          </p>
        </div>
      </div>
    </div>
  )
}
